export class GetFields {
  static readonly type = '[Field] Get fields';

  constructor(public payload: string[]) {
  }
}
